<template>
    <div v-on-clickout="hideNav" class="d-flex">
        <li v-if="warningNumber > 0" @click="getWarning" class="nav-item dropdown border-left notifications mr-0">
            <a class="nav-link nav-link-icon text-center" @click="isWarningActive = !isWarningActive">
                <div class="nav-link-icon__wrapper">
                    <i class="material-icons">&#xe002;</i>
                    <d-badge v-if="warningNumber > 0" pill theme="danger">{{ warningNumber }}</d-badge>
                </div>
            </a>
            <d-collapse v-model="isWarningActive" id="warnings" class="dropdown-menu dropdown-menu-small notification">
                <div v-if="warning.length !== 0">
                    <d-dropdown-item :href="$route.name" v-if="warning['subscription-expired']">
                        <div class="notification__icon-wrapper">
                            <div class="notification__icon">
                                <i class="material-icons">&#xE6E1;</i>
                            </div>
                        </div>
                        <div>
                            <div class="notification__content">
                                <span class="notification__category">SUBSCRIPTION</span>
                                <p>{{ warning['subscription-expired'] }}</p>
                            </div>
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item :href="$route.name" v-if="warning['domain-failed-connections'] !== null" v-for="warning in warning['domain-failed-connections']">
                        <div class="notification__icon-wrapper">
                            <div class="notification__icon">
                                <i class="fa">&#xf0ac;</i>
                            </div>
                        </div>
                        <div>
                            <div class="notification__content">
                                <span class="notification__category">FAILED CONNECTION</span>
                                <p>{{ warning.text }}</p>
                            </div>
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item :href="$route.name" v-if="warning['integration-failed-connections'] !== null" v-for="warning in warning['integration-failed-connections']">
                        <div class="notification__icon-wrapper">
                            <div class="notification__icon">
                                <i class="material-icons">&#xe8b8;</i>
                            </div>
                        </div>
                        <div>
                            <div class="notification__content">
                                <span class="notification__category">FAILED INTEGRATION</span>
                                <p>{{ warning.text }}</p>
                            </div>
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item :href="$route.name" v-if="warning['ga-connection-disconnected'] !== null" v-for="warning in warning['ga-connection-disconnected']">
                        <div class="notification__icon-wrapper">
                            <div class="notification__icon">
                                <i class="material-icons">&#xe8b8;</i>
                            </div>
                        </div>
                        <div>
                            <div class="notification__content">
                                <span class="notification__category">FAILED INTEGRATION</span>
                                <p>{{ warning.text }}</p>
                            </div>
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item :href="$route.name" v-if="warning['reached-max-amount']">
                        <div class="notification__icon-wrapper">
                            <div class="notification__icon">
                                <i class="material-icons">&#xE6E1;</i>
                            </div>
                        </div>
                        <div>
                            <div class="notification__content">
                                <span class="notification__category">PLAN LIMIT</span>
                                <p>{{ warning['reached-max-amount'] }}</p>
                            </div>
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item :href="$route.name" v-if="warning['ga-connection-was-not-set-property-id']">
                        <div class="notification__icon-wrapper">
                            <div class="notification__icon">
                                <i class="material-icons">&#xE6E1;</i>
                            </div>
                        </div>
                        <div>
                            <div class="notification__content">
                                <span class="notification__category">GOOGLE ANALYTICS CONNECTION</span>
                                <p>{{ warning['ga-connection-was-not-set-property-id'][0].text }}</p>
                            </div>
                        </div>
                    </d-dropdown-item>
                    <d-dropdown-item id="hide" class="notification__all text-center" v-d-toggle.warnings>Hide</d-dropdown-item>
                </div>
                <div v-else>
                    <b-spinner label="Spinning"></b-spinner>
                </div>
            </d-collapse>
        </li>

        <li class="nav-item border-left border-right dropdown mr-0 notifications">
            <a class="nav-link nav-link-icon text-center" @click="isNotificationActive = !isNotificationActive">
                <div @click="getUnread" class="nav-link-icon__wrapper">
                    <i class="material-icons">&#xE7F4;</i>
                    <d-badge v-if="notificationsNumber > 0" pill theme="danger">{{ notificationsNumber }}</d-badge>
                </div>
            </a>
            <d-collapse v-model="isNotificationActive" id="notifications" class="dropdown-menu dropdown-menu-small notification">
                <d-dropdown-item v-for="notification in notifications" :href="notification.data.data.action.link.type == 'external' ? notification.data.data.action.link.href : `/${notification.data.data.action.link.href}`">
                    <div class="notification__icon-wrapper">
                        <div class="notification__icon">
                            <i class="material-icons">&#xe7f4;</i>
                        </div>
                    </div>
                    <div class="notification__content">
                        <span class="notification__category">NOTIFICATION</span>
                        <p>{{ notification.data.data.text }}</p>
                    </div>
                </d-dropdown-item>
                <d-dropdown-item v-if="notificationsNumber <= 0" :href="$route.name">
                    <div class="notification__icon-wrapper">
                        <div class="notification__icon">
                            <i class="material-icons">&#xe7f4;</i>
                        </div>
                    </div>
                    <div class="notification__content">
                        <span class="notification__category">NOTIFICATION</span>
                        <p>You have no new notifications</p>
                    </div>
                </d-dropdown-item>
                <d-dropdown-item id="hide" v-if="notificationsNumber <= 0" class="notification__all text-center" v-d-toggle.notifications>Hide</d-dropdown-item>
                <div v-if="notificationsNumber > 0" @click="read" v-d-toggle.notifications>
                    <d-dropdown-item class="notification__all text-center">Mark all as read</d-dropdown-item>
                </div>
            </d-collapse>
        </li>
    </div>
</template>

<script>
    import { NotificationService } from '@/main';
    import env from '@/mixins/env';
    import { mixin as clickout } from 'vue-clickout';
    import NotificationCenter from '@/components/common/NotificationCenter.vue';
    import * as Sentry from "@sentry/browser";

    export default {
        mixins: [env, clickout],

        data() {
            return {
                notificationsNumber: 0,
                warningNumber: 0,
                warning: [],
                notifications: [],
                isWarningActive: false,
                isNotificationActive: false
            }
        },

        methods: {
            async getNotificationNumber() {
                let numberValue = {}
                try {
                    const number = await NotificationService.getNumber()
                    numberValue = number
                    this.notificationsNumber = number.notifications
                    this.warningNumber = number.warnings
                    this.notifications = []
                    this.warning = []
                } catch(err) {
                    Sentry.captureException(err)
                    Sentry.captureMessage(err)
                    Sentry.captureMessage(numberValue)
                    Sentry.captureMessage('get number error')
                }
            },

            async getWarning() {
                this.isNotificationActive = false
                document.getElementById("hide").removeAttribute("href")

                if (this.warning.length == 0) {
                    this.warning = await NotificationService.getWarning()
                }
            },

            async read() {
                await NotificationService.read()
                this.notifications = []
                this.notificationsNumber = 0
            },

            async getUnread() {
                this.isWarningActive = false
                // document.getElementById("hide").removeAttribute("href") // todo fix it @Alexander

                if (this.notifications.length == 0) {
                    this.notifications = await NotificationService.getUnread()
                }
            },

            hideNav() {
                this.isWarningActive = false,
                this.isNotificationActive = false
            }
        },

        created() {
            this.getNotificationNumber()
        },
    }
</script>
